import Vue from 'vue'
import Router from 'vue-router'
import Index from '../components/Index'
import SchedulingManagementSystem from '../components/SchedulingManagementSystem'
import Partner from '../components/Partner'
import AboutUs from '../components/AboutUs'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'Index',
            component: Index
        },
        {// 排班管理系统
            path: '/SchedulingManagementSystem',
            name: 'SchedulingManagementSystem',
            component: SchedulingManagementSystem
        },
        {// 合作伙伴
            path: '/Partner',
            name: 'Partner',
            component: Partner
        },
        {// 关于我们
            path: '/AboutUs',
            name: 'AboutUs',
            component: AboutUs
        },
    ]
})
